import React from "react";
import PokeCardList from "../components/PokeCardList";
import Title from "../components/Title";
import styled from "styled-components";

const GlobalStyleds = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
`;

function Home() {
    return (
        <GlobalStyleds>
            <Title />
            <PokeCardList />
        </GlobalStyleds>

    );
};

export default Home;